import { TrendingUp } from "lucide-react";

const Tile = ({ label, items, tone, testId, icon: Icon }) => (
  <div className={`rounded-2xl border p-5 ${tone}`} data-testid={testId}>
    <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider">{Icon && <Icon size={13} />}{label}</p>
    <p className="mt-2 text-3xl font-bold text-slate-900">{items.length}</p>
    <p className="mt-1 line-clamp-2 text-xs text-slate-700">{items.length ? items.map((p) => p.name).join(", ") : "None this period"}</p>
  </div>
);

export const SentimentIndex = ({ provinces }) => {
  if (!provinces) return null;
  const withNews = provinces.filter((p) => p.article_count > 0);
  return (
    <div className="mt-6" data-testid="community-sentiment-index">
      <p className="text-sm font-semibold text-slate-900">News tone by region <span className="font-normal text-slate-600">· provinces and territories</span></p>
      <div className="mt-3 grid grid-cols-2 gap-3 lg:grid-cols-4">
        <Tile label="Positive" items={withNews.filter((p) => p.score >= 60)} tone="border-emerald-200 bg-emerald-50 text-emerald-800" testId="index-positive" />
        <Tile label="Neutral" items={withNews.filter((p) => p.score >= 40 && p.score < 60)} tone="border-amber-200 bg-amber-50 text-amber-800" testId="index-neutral" />
        <Tile label="Concern areas" items={withNews.filter((p) => p.score < 40)} tone="border-rose-200 bg-rose-50 text-rose-800" testId="index-concern" />
        <Tile label="Improving trends" icon={TrendingUp} items={withNews.filter((p) => p.delta > 0)} tone="border-sky-200 bg-sky-50 text-sky-900" testId="index-improving" />
      </div>
    </div>
  );
};
